import React from "react";
import {
  Box,
  Typography,
  Stack,
  CircularProgress
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GroupsIcon from "@mui/icons-material/Groups";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DescriptionIcon from "@mui/icons-material/Description";
import { CandidateStatusHistory } from "./CandidateProfile";



interface ActivityTimelineProps {
  statusHistory: CandidateStatusHistory[];
  loading: boolean;
}

const iconMap: Record<string, React.ReactNode> = {
  Screening: <SearchIcon sx={{ color: "#a084e8" }} />,
  Shortlisted: <CheckCircleIcon sx={{ color: "#4caf50" }} />,
  "HR Interview": <PersonIcon sx={{ color: "#2196f3" }} />,
  Assessment: <AssignmentIcon sx={{ color: "#ff9800" }} />,
  "Panel Interview": <GroupsIcon sx={{ color: "#673ab7" }} />,
  "Preboarding": <EventAvailableIcon sx={{ color: "#009688" }} />,
  "On Hold": <PauseCircleIcon sx={{ color: "#ffc107" }} />,
  Rejected: <CancelIcon sx={{ color: "#f44336" }} />,
};



const ActivityTimeline: React.FC<ActivityTimelineProps> = ({ statusHistory, loading }) => {
  return (
    <Box>
      <Typography variant="subtitle2"  mb={2}>
        Activity History
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={3}>
          <CircularProgress size={24} />
        </Box>
      ) : statusHistory.length === 0 ? (
        <Typography variant="body2" color="text.secondary" ml={1}>
          No activity yet. Candidate's progress will appear here.
        </Typography>
      ) : (
        <Stack spacing={2} position="relative" ml={1}>
          {statusHistory.map((item, index) => (
            <Box key={index} display="flex" alignItems="flex-start">
              <Stack spacing={1} alignItems="center" mr={2}>
                {iconMap[item.Status] || <DescriptionIcon sx={{ color: "#a084e8" }} />}
                {index !== statusHistory.length - 1 && (
                  <Box width="2px" height="40px" bgcolor="#d3d3d3" mt={0.5} />
                )}
              </Stack>
              <Box>
                <Typography fontWeight="medium">{item.Status}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.UpdatedDate}
                </Typography>
              </Box>
            </Box>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default ActivityTimeline;


